import { APP_ROUTES } from "@/constants/routes";
import { EPrioritizeReport } from "@/models/report";

export const getRedirectUrl = (
  slug: string,
  locale: string,
  prioritize: number[],
  isHaveEmbed: boolean,
  isHavePdf: boolean,
  isHaveInteractive: boolean
): string => {
  const priorities = Array.isArray(prioritize)
    ? prioritize
    : [
        EPrioritizeReport.PDF,
        EPrioritizeReport.POWERBI,
        EPrioritizeReport.EMBED,
      ];

  let mode = "";
  for (const p of priorities) {
    if (p === EPrioritizeReport.EMBED && isHaveEmbed) {
      mode = "embed";
      break;
    } else if (p === EPrioritizeReport.POWERBI && isHaveInteractive) {
      mode = "powerbi";
      break;
    } else if (p === EPrioritizeReport.PDF && isHavePdf) {
      mode = "pdf";
      break;
    }
  }
  if (mode) {
    return APP_ROUTES(locale).HOME.DETAIL.to(slug, mode);
  } else {
    return APP_ROUTES(locale).HOME.DETAIL.to(slug, "pdf");
  }
};
